import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { DownloadDocumentQueryResponse, DownloadDocumentPathParams, DownloadDocument404, DownloadDocument500 } from "../types/DownloadDocument";

export const downloadDocumentQueryKey = (documentId: DownloadDocumentPathParams["documentId"]) =>     [{url:`/api/documents/${documentId}`,params:{documentId:documentId}}] as const;
      export function downloadDocumentQueryOptions <TData = DownloadDocumentQueryResponse, TError = DownloadDocument404 | DownloadDocument500>(documentId: DownloadDocumentPathParams["documentId"], options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = downloadDocumentQueryKey(documentId, );

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/documents/${documentId}`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Запрос на получение документа
 * @link /api/documents/:documentId
 */

export function useDownloadDocument <TData = DownloadDocumentQueryResponse, TError = DownloadDocument404 | DownloadDocument500>(documentId: DownloadDocumentPathParams["documentId"], options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? downloadDocumentQueryKey(documentId, );

  const query = useQuery<TData, TError>({
    ...downloadDocumentQueryOptions<TData, TError>(documentId, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
